export default __webpack_public_path__ + "static/media/select.d54c816d.wav";